module.exports = __webpack_public_path__ + "static/media/launch-bg.7be3e646.webp";